import React from "react";

const MissionSection = () => {
  return (
    <section className="bg-reddark text-white px-6 py-16">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Left: Mission Text */}
        <div className="md:w-1/2 text-center md:text-left  p-3">
          <h2 className="text-3xl md:text-4xl font-serif font-medium leading-[1.2]">
            Our mission is to leverage advanced technology to design and develop
            experiences that simplify people's lives.
          </h2>
        </div>

        {/* Right: Bird Illustration */}
        <div className="md:w-1/2 shadow-lg">
          <img
            src={
              "https://images.pexels.com/photos/2629372/pexels-photo-2629372.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            }
            alt="Flying bird illustration"
            className="w-full max-w-lg mx-auto md:mx-0 rounded-2xl grayscale border-2 border-textGray"
          />
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
